export const translations = {
  sair: {
    pt: 'Sair',
    en: 'Exit',
    de: 'Schließen',
    es: 'Salir',
  },
};
